export default "https://cdn-static.gokick.com/assets/bf292cd7043bd3c72a48f3c1f30d1b93bc9276ca/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";